<template>
  <div :class="rootClass">
    <Header></Header>
    <div class="top-video" v-if="showVideo && !isMobile">
      <video class="video" muted="" loop="loop" autoplay="autoplay" preload="auto">
        <source src="../assets/img/video.mp4" type="video/mp4">
      </video>
      <div class="video-mask"></div>
    </div>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import { getUrlParam } from '../utils/utils'
import { mapGetters } from 'vuex'
// import { checkoutItemInWindow } from '../utils/utils'
export default {
  data () {
    return {
      rootClass: 'main',
      showVideo: (getUrlParam('type') === '' || getUrlParam('type') === null) && (getUrlParam('id') === '' || getUrlParam('id') === null)
    }
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'gameInfo',
      'navArticleType'
    ]),
    isMobile () {
      return this.deviceType === 'mobile'
    }
  },
  beforeUpdate () {
    this.showVideo = (getUrlParam('type') === '' || getUrlParam('type') === null) && (getUrlParam('id') === '' || getUrlParam('id') === null)
  },
  mounted () {
    // checkoutItemInWindow('.links', '.fadeIn')
  },
  methods: {
    setClass () {
      let path = this.$router.currentRoute.path.slice(1) || 'main'
      this.rootClass = 'container-' + ((path.indexOf('/') !== -1) ? path.slice(0, path.indexOf('/')) : path)
    }
  },
  created () {
    this.setClass()
  },
  updated () {
    this.setClass()
  },
  components: {
    Header,
    Footer
  }
}
</script>

<style lang="scss">
  .container-main {
    height: 4000px;
    width: 100%;
    min-width: 1200px;
    background: url('../assets/img/bg-main.jpg') no-repeat center top;
  }
  .container-article-list, .container-article-detail {
    width: 100%;
    min-height: 1800px;
    min-width: 1200px;
    background: url('../assets/img/bg-article.jpg') no-repeat center top;
  }
  .container-article-detail {
    min-height: 0;
  };
  // 移动端适配
  #mobile {
    .container-main {
      height: 5164px;
      width: 750px;
      min-width: 75px;
      background: url('../assets/img/bg-m.jpg') no-repeat center top;
      background-size: 100%;
    }
    .container-article-list, .container-article-detail {
      min-height: 1218px;
      min-width: 750px;
      background: white;
    }
  }
</style>
